import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { SHUFFLE_OFF, SHUFFLE_ON } from '../../actions/Playback';
export default function ShuffleButton(props) {
    var _a, _b;
    const dispatch = useDispatch();
    const { shuffle } = useSelector((state) => state.PlaybackStates);
    const variant = ((_a = shuffle) === null || _a === void 0 ? void 0 : _a.state) === 'ON' ? 'accent' : 'primary';
    const text = (_b = shuffle) === null || _b === void 0 ? void 0 : _b.descriptions[shuffle.state];
    if (!shuffle) {
        return React.createElement("div", { style: { display: 'none' } });
    }
    return (React.createElement("music-button", { "aria-label": text, onClick: handleClick, variant: variant, "icon-name": "shuffle", "icon-only": true, size: props.size || 'small' }, text));
    function handleClick(e) {
        if (!e.target.disabled && shuffle) {
            if (shuffle.state === 'ON') {
                dispatch({ type: SHUFFLE_OFF });
            }
            else {
                dispatch({ type: SHUFFLE_ON });
            }
        }
    }
}
;
